export default "# Anwaltspostfach\n\n**Die beA App**\n\nfür [iPhone](./bea-iphone), [iPad](./bea-ipad) & [Mac](./bea-mac)\n\n**gratis ausprobieren**.\n";